import { FC } from 'react';
import { Plus } from 'lucide-react';
import { Can } from '@new/casl';
import { useNavigate } from '@tanstack/react-router';

interface TutorialsHeaderProps {
  count: number;
}

export const TutorialsHeader: FC<TutorialsHeaderProps> = () => {
  const navigate = useNavigate();

  const handleCreate = () => {
    navigate({ to: '/create-newlane-tutorials' });
  };

  return (
    <div className="flex justify-between items-center self-stretch">
      <div className="flex flex-col gap-2">
        <h1 className="[font-size:var(--fs-h2)] font-bold text-(--neutral-black-NB900)! mb-1!">
          Newlane Tutorials
        </h1>
      </div>

      <Can I="manage" a="Course">
        <button
          onClick={handleCreate}
          className="flex items-center lg:gap-2 px-1 lg:px-4.5! py-1 lg:py-3.25! border-2! border-(--primary-O900)! rounded-[6px]! lg:rounded-md! cursor-pointer"
        >
          <Plus
            size={16}
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-(--primary-O900)"
          />
          <p className="hidden lg:block [font-size:var(--fs-b3)]! [font-family:var(--font-arvo)]! text-(--primary-O900)! bold m-0!">
            Create Tutorial
          </p>
        </button>
      </Can>
    </div>
  );
};
